import { print } from 'graphql'
import gql from 'graphql-tag'

import axiosql from '../axiosql'

function load() {
    return axiosql('public/graphql', {
        query: print(gql`
            {
                plans {
                    _id
                    name
                    nickname
                    description
                    billingInterval
                    billingAmount
                    billingAmountPerGB
                    billingAmountPerHour
                    initialCharge
                    dataCap
                    timeCap
                    accessLevel
                    deviceLimit
                }
            }
        `)
    })
}

function loadByID(id) {
    return axiosql('public/graphql', {
        query: print(gql`
            query getPlanByID($id: String!) {
                plans(filter: { _id: $id }) {
                    _id
                    name
                    nickname
                    description
                    billingInterval
                    billingAmount
                    billingAmountPerGB
                    billingAmountPerHour
                    initialCharge
                    dataCap
                    timeCap
                    accessLevel
                    deviceLimit
                }
            }
        `),
        variables: {
            id
        }
    })
}

export { load, loadByID }
